import { render } from "./RegisterTMS.vue?vue&type=template&id=3b6b876e&scoped=true"
import script from "./RegisterTMS.vue?vue&type=script&lang=js"
export * from "./RegisterTMS.vue?vue&type=script&lang=js"

import "./RegisterTMS.vue?vue&type=style&index=0&id=3b6b876e&scoped=true&lang=css"

import exportComponent from "D:\\bkp\\my-vue-pwa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6b876e"]])

export default __exports__